import { withVariants, FormControl } from '@hvccc/component-library';
import ReportFilterControl from './ReportFilterControl';

const variants = {
  'report-filter': ReportFilterControl,
};

export default withVariants(variants)(FormControl);
